var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 11,
    cy: 12,
    cx: 12,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 22.284,
    cy: 2.232,
    cx: 11.935,
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafafb",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8cdd1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 11,
    cy: 12,
    cx: 12,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 22.284,
    cy: 2.232,
    cx: 11.935,
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafafb",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8cdd1",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 20.485,
    y1: 3.515,
    x2: 20.485,
    x1: 3.515,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889097",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64717c",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 20.485,
    y1: 3.515,
    x2: 20.485,
    x1: 3.515,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889097",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64717c",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34 11-6-6h-8l-6 6h-3v28c0 2.2 1.8 4 4 4h18c2.2 0 4-1.8 4-4V11h-3z",
    fill: "#ff3d00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7h26c1.1 0 2 .9 2 2v2H9V9c0-1.1.9-2 2-2z",
    fill: "#ff6e40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.586 31.586 12-12 2.829 2.828-12 12z",
    fill: "#fafafa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.586 22.415 2.828-2.829 12 12-2.828 2.829z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.727 24.727) scale(.8864)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "url(#c)",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "url(#e)",
    style: {
      fill: "url(#f)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#45494d",
    d: "M12 12.5a.5.5 0 0 1-.354-.853l5.091-5.091a.5.5 0 0 1 .707.707l-5.091 5.091A.498.498 0 0 1 12 12.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#45494d",
    d: "M11.999 12.75a.741.741 0 0 1-.334-.079l-6-3a.75.75 0 0 1 .67-1.342l6 3a.75.75 0 0 1-.336 1.421z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.5,
    fill: "#1e2021"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetExpire);
export default __webpack_public_path__ + "static/media/datasetExpire.37d89fd8ea0f1ee051a2efdc929e36a7.svg";
export { ForwardRef as ReactComponent };